import { useMediaQuery } from '@carvana/helios-layout';
import { breakpoint } from '@carvana/helios-styles';

const useLayoutSize = () => {
  const isXs = useMediaQuery(`(min-width: ${breakpoint.xs})`);
  const isSm = useMediaQuery(`(min-width: ${breakpoint.sm})`);
  const isLegacySm = useMediaQuery(`(min-width: 768px)`);
  const isMd = useMediaQuery(`(min-width: ${breakpoint.md})`);
  const isLg = useMediaQuery(`(min-width: ${breakpoint.lg})`);
  const isXl = useMediaQuery(`(min-width: ${breakpoint.xl})`);

  const isOnlyXs = useMediaQuery(`(min-width: ${breakpoint.xs}) and (max-width: ${breakpoint.sm})`);
  const isOnlySm = useMediaQuery(`(min-width: ${breakpoint.sm}) and (max-width: ${breakpoint.md})`);
  const isOnlyMd = useMediaQuery(`(min-width: ${breakpoint.md}) and (max-width: ${breakpoint.lg})`);
  const isOnlyLg = useMediaQuery(`(min-width: ${breakpoint.lg}) and (max-width: ${breakpoint.xl})`);
  const isOnlyXl = useMediaQuery(`(min-width: ${breakpoint.xl})`);

  return {
    isXs,
    isSm,
    isLegacySm,
    isMd,
    isLg,
    isXl,
    isOnlyXs,
    isOnlySm,
    isOnlyMd,
    isOnlyLg,
    isOnlyXl
  };
};

export default useLayoutSize;
